export const activityTypes = [
    {
        id: 1,
        value: "Espace sport",
        color: "bg-primary",
    },
    {
        id: 2,
        value: "Espace santé",
        color: "bg-activity-type2",

    },
    {
        id: 3,
        value: "Espace bien-être",
        color: "bg-activity-type3",
    }
]

export const activityTypeMember = [
    {
        id : 1,
        value : "Particulier"
    },
    {
        id: 2,
        value : "Pro"
    }
]

export const activityStatus = [
    {
        id : 1,
        value: "Brouillon",
        valuetest: "brouillon"
    },
    {
        id: 2,
        value: "Publié",
        valuetest: "publié"
    }
]